import { StarFillIcon, Typography, TypographyType } from '@vivino/js-react-common-ui';
import { ValueForMoneyScoresFull, useI18N } from '@vivino/js-web-common';
import cx from 'classnames';
import React from 'react';

import VFMBadge from '@components/VFMScale/components/VFMBadge/VFMBadge';

import styles from './ratingScale.module.scss';

const TRANSLATIONS = {
  thisWinesRating: 'components.shared.vfm_scale.this_wines_rating',
  otherWinesRating: 'components.shared.vfm_scale.average_rating_for_similar_wines',
};

interface RatingScaleProps extends ValueForMoneyScoresFull {
  requested_rating?: number;
}

const RatingScale = ({ qprScores }: { qprScores: RatingScaleProps }) => {
  const { t } = useI18N();
  function getBadgePosition(rating) {
    const maxrating = 5;
    const minrating = 1;

    if (rating >= minrating && rating <= maxrating) {
      const percent = ((rating - minrating) / (maxrating - minrating)) * 100;
      return percent;
    }
    return;
  }

  const vintageGroupRating = qprScores?.peer_group?.rating || 0;
  const vintageRating = qprScores?.requested_rating || 0;
  const vintageRatingPostion = getBadgePosition(vintageRating);
  const averageRatingPosition = getBadgePosition(vintageGroupRating);
  return (
    <div className={styles.ratingsContainer}>
      <div className={styles.gradient}>
        <div className={styles.rating}>
          <StarFillIcon className={cx(styles.star, styles.disabledStar)} />1
        </div>
        <div className={styles.gradientContainer}>
          <div className={styles.marker} style={{ left: `${vintageRatingPostion}%` }}>
            <div className={styles.categoryTitle}>
              <VFMBadge
                text={qprScores?.value_category?.title}
                position={qprScores?.value_category?.barometer_position}
              />
            </div>
            <div className={styles.text}>
              <Typography type={TypographyType.Caption}>
                {t(TRANSLATIONS.thisWinesRating)}
              </Typography>
              <div className={styles.rating}>
                <StarFillIcon className={cx(styles.star, styles.redStar)} />
                <Typography type={TypographyType.LabelMedium}>
                  {Number(vintageRating).toFixed(1)}
                </Typography>
              </div>
            </div>
          </div>
          <div className={styles.rails}>
            <div className={styles.track}></div>
            <div className={styles.track}></div>
            <div className={styles.track}></div>
            <div className={styles.track}></div>
            <div className={styles.track}></div>
            <div
              className={styles.progressBar}
              style={{ width: `${100 - vintageRatingPostion}%` }}
            ></div>
          </div>
          <div className={styles.averageRating} style={{ left: `${averageRatingPosition}%` }}>
            <div className={styles.title}>{t(TRANSLATIONS.otherWinesRating)}</div>
            <div></div>
          </div>
        </div>
        <div className={styles.rating}>
          <StarFillIcon className={cx(styles.star, styles.disabledStar)} />5
        </div>
      </div>
    </div>
  );
};

export default RatingScale;
